var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/* eslint-disable @typescript-eslint/no-floating-promises */
/* istanbul ignore file */
import { BroadcastType, createPennyBroadcastSubscriber } from '../utils/pennyBroadcast';
import analytics from '../analytics';
import fetchWithTimeout from '../utils/fetchWithTimeout';
var SpeechFetcher = /** @class */function () {
  function SpeechFetcher(speechUrl, timeout) {
    if (speechUrl === void 0) {
      speechUrl = 'https://www.priceline.com/genai-svc/genai/audio/speech';
    }
    if (timeout === void 0) {
      timeout = 10000;
    }
    this.currentAudio = null;
    this.textQueue = [];
    this.audioQueue = [];
    this.isFetching = false;
    this.isPlaying = false;
    this.isDestroying = false;
    this.timeout = timeout;
    this.speechUrl = speechUrl;
    this.fullTranscript = '';
    this.broadcastChannel = createPennyBroadcastSubscriber();
  }
  SpeechFetcher.prototype.destroy = function () {
    this.isDestroying = true;
    this.broadcastChannel.close();
    this.broadcastChannel = null;
    if (this.currentAudio) {
      this.currentAudio.pause();
      URL.revokeObjectURL(this.currentAudio.src); // Clean up the object URL
      this.currentAudio = null;
    }
  };
  SpeechFetcher.prototype.addToQueue = function (text, messageId) {
    this.textQueue.push({
      text: text,
      messageId: messageId
    });
    if (!this.isFetching) {
      this.processQueue();
    }
    this.fullTranscript += text;
  };
  SpeechFetcher.prototype.processQueue = function () {
    return __awaiter(this, void 0, void 0, function () {
      var textToSynthesize, audioBlob, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.isDestroying) {
              return [2 /*return*/];
            }
            if (this.textQueue.length === 0) {
              this.isFetching = false;
              if (this.audioQueue.length > 0 && !this.isPlaying) {
                this.playNextAudio();
              }
              return [2 /*return*/];
            }
            this.isFetching = true;
            textToSynthesize = this.textQueue.shift();
            if (!textToSynthesize) {
              return [2 /*return*/];
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, this.fetchSpeech(textToSynthesize)];
          case 2:
            audioBlob = _a.sent();
            this.audioQueue.push({
              text: textToSynthesize.text,
              messageId: textToSynthesize.messageId,
              audioBlob: audioBlob
            });
            if (!this.isPlaying) {
              this.playNextAudio();
            }
            return [3 /*break*/, 5];
          case 3:
            error_1 = _a.sent();
            analytics.logError({
              message: 'Failed to fetch speech',
              error: JSON.stringify(error_1)
            });
            return [3 /*break*/, 5];
          case 4:
            this.isFetching = false;
            this.processQueue();
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };
  SpeechFetcher.prototype.fetchSpeech = function (message) {
    return __awaiter(this, void 0, void 0, function () {
      var speechResponse;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.broadcastChannel) return [3 /*break*/, 3];
            this.broadcastChannel.postMessage({
              type: BroadcastType.AUDIO_RETRIEVAL_INITIATED,
              data: message.text,
              sender: 'SpeechFetcher'
            });
            return [4 /*yield*/, fetchWithTimeout(this.speechUrl, {
              method: 'POST',
              body: JSON.stringify({
                text: message.text,
                useCustomVoice: true
              }),
              headers: {
                'Content-Type': 'application/json',
                accept: 'audio/mpeg'
              },
              timeout: this.timeout
            })];
          case 1:
            speechResponse = _a.sent();
            if (!speechResponse.ok) {
              throw new Error("Speech fetch failed: ".concat(speechResponse.statusText));
            }
            return [4 /*yield*/, speechResponse.blob()];
          case 2:
            return [2 /*return*/, _a.sent()];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  SpeechFetcher.prototype.playNextAudio = function () {
    return __awaiter(this, void 0, void 0, function () {
      var audioData, audio;
      var _this = this;
      return __generator(this, function (_a) {
        // If the broadcast channel is null, that means we shouldn't be playing audio
        if (!this.broadcastChannel) {
          return [2 /*return*/];
        }
        if (this.audioQueue.length === 0 && !this.isPlaying) {
          setTimeout(function () {
            if (!_this.isPlaying && !_this.isDestroying) {
              // Audio playback ended and nothing started playing for 2 seconds, we can assume
              // there is no more audio to play
              _this.broadcastChannel.postMessage({
                type: BroadcastType.AUDIO_QUEUE_DRAINED,
                sender: 'SpeechFetcher.playNextAudio().timeout()'
              });
              _this.isPlaying = false;
            }
          }, 2000);
          return [2 /*return*/];
        }
        audioData = this.audioQueue.shift();
        audio = new Audio();
        // If we have audio data and the tab containing penny is active, play the audio
        if (audioData && audio && !document.hidden) {
          audio.src = URL.createObjectURL(audioData.audioBlob);
          this.currentAudio = audio; // Update the current audio reference
          this.isPlaying = true;
          this.broadcastChannel.postMessage({
            type: BroadcastType.AUDIO_PLAYBACK_STARTED,
            data: audioData.text,
            sender: 'SpeechFetcher.playNextAudio()'
          });
        }
        return [2 /*return*/, new Promise(function (resolve) {
          audio.onended = function () {
            // set is playing to false in context
            URL.revokeObjectURL(audio.src);
            _this.isPlaying = false;
            _this.broadcastChannel.postMessage({
              type: BroadcastType.AUDIO_PLAYBACK_STOPPED,
              hasMoreMessages: !!(_this.audioQueue.length || _this.textQueue.length),
              sender: 'SpeechFetcher.playNextAudio().onended()'
            });
            _this.currentAudio = null; // Reset the current audio reference
            _this.playNextAudio();
            resolve();
          };
          audio.onerror = function () {
            _this.isPlaying = false;
            _this.broadcastChannel.postMessage({
              type: BroadcastType.AUDIO_PLAYBACK_STOPPED,
              hasMoreMessages: !!(_this.audioQueue.length || _this.textQueue.length),
              sender: 'SpeechFetcher.playNextAudio().onerror()'
            });
            _this.currentAudio = null; // Reset on error as well
            analytics.logError({
              message: 'Audio playback failed'
            });
          };
          audio.play().catch(function (error) {
            return analytics.logError({
              message: 'Audio playback failed',
              error: JSON.stringify(error)
            });
          });
        })];
      });
    });
  };
  SpeechFetcher.prototype.stopPlaybackAndClearQueue = function () {
    if (this.currentAudio) {
      this.currentAudio.pause();
      URL.revokeObjectURL(this.currentAudio.src); // Clean up the object URL
      this.currentAudio = null;
    }
    // Clear both the audio and text queues
    this.audioQueue.length = 0;
    this.textQueue.length = 0;
    this.audioQueue = [];
    this.textQueue = [];
    // Reset playback and fetching flags
    this.isPlaying = false;
    this.isFetching = false;
    // Broadcast that the queue has been drained (since we're not going to play the audio) and
    // the UI can clean itself up in response.
    this.broadcastChannel.postMessage({
      type: BroadcastType.AUDIO_QUEUE_DRAINED,
      sender: 'SpeechFetcher'
    });
    // Trigger the audio end callback to ensure consistent state and callbacks
    this.broadcastChannel.postMessage({
      type: BroadcastType.AUDIO_PLAYBACK_STOPPED,
      hasMoreMessages: !!(this.audioQueue.length || this.textQueue.length),
      sender: 'SpeechFetcher.stopPlaybackAndClearQueue()'
    });
  };
  return SpeechFetcher;
}();
export default SpeechFetcher;